import { useContext } from 'react';
import { AppContext, IAppContext } from '@livewire/website/src/context';

export const useApp = (): IAppContext => useContext(AppContext);

export default useApp;
